import http from "./http"
const system = {
  getStat() {
    return http.get("home/info")
  },
  getName() {
    return http.get("sys/getName")
  },
}
export default system
